import { post } from "jquery";

(function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { OffreEmploiDetail : {}});
    
    /**
     * Initialisation 
     */
    w.Kinougarde.OffreEmploiDetail.initialisation = function(reference) { 

        //window.history.pushState({reference : reference, url : document.location.pathname},null);

        var defautlValue = Kinougarde.GetStorage("form-recherche-offres");
        if (typeof(defautlValue)!=='undefined' && defautlValue!==null) {                        
            //Une recherche à déjà été effectuée
            // On affiche le bouton de retour à la liste
            $("#section-detail-offre-emploi-btn-retour-list").removeClass("hidden");
            $("#section-detail-offre-emploi-btn-offres-proximite").removeClass("button green alt");
            $("#section-detail-offre-emploi-btn-offres-proximite").addClass("ref");
        } 

        // Supression du bouton "Postuler" si l'utilisateur à déjà postulé à cette offre
        // Ajout de la reference de l'offre dans la liste des offres déjà vues
        try {
            var offresDejaPostulee = Kinougarde.GetStorage("offres-emploi-postulees");
            if (typeof(offresDejaPostulee)!=='undefined' && offresDejaPostulee!==null) {                
                if (offresDejaPostulee.indexOf(reference)>=0) {
                    // L'utilisateur a déjà postulé à cette offre
                    $("#section-detail-offre-emploi-btn-postuler").parent().html('<span class="deja-postule">DÉJÀ POSTULÉ</span>');
                }
            }

        }
        catch(e) {}
        
        // Capte le click sur le bouton postuler
        $("#section-detail-offre-emploi-btn-postuler").on('click',function(e) {
            try {
            var postuler = Kinougarde.GetStorage("form-postuler");
            if (typeof(postuler)!=='undefined' && postuler!==null) {
                // Si une candidature a déjà été faite, on ajoute cette offre d'emploi à la candidature précédente
                e.preventDefault();
                Kinougarde.OffreEmploiDetail.PostulerComplementaire(reference,postuler.id,postuler.prenom);
            } else {
                Kinougarde.TagManagerTunnel('Postuler/step-0',{'data-tracking-kpi':'intervenant-postuler-offre-cta'});
                document.location.href = "/postuler/?job_id=" +reference;
                // redirection  vers la page postuler                
            }
            }   
            catch (e) {
                // redirection  vers la page postuler                
                Kinougarde.TagManagerTunnel('Postuler/step-0',{'data-tracking-kpi':'intervenant-postuler-offre-cta'});
                document.location.href = "/postuler/?job_id=" +reference;
            }
        });

        

        // Ajout de la reference de l'offre dans la liste des offres déjà vues
        try {
        var offresDejaVues = Kinougarde.GetStorage("offres-emploi-vues");
        if (typeof(offresDejaVues)==='undefined' || offresDejaVues===null) {
            offresDejaVues= [];
        }
        // Ajout uniquement si non présent dans offresDejaVues       
        offresDejaVues.push(reference);        
        Kinougarde.SetStorage("offres-emploi-vues",offresDejaVues.filter((item, pos) => offresDejaVues.indexOf(item) === pos));
        } catch (e) {}

        //Tracking analytics
        Kinougarde.TagManagerTunnel('Offres/step-2');


    }

    /**
     * Ajout de l'offre en cours sur la candidature pécédente
     * @param {Envoi} reference 
     */
    w.Kinougarde.OffreEmploiDetail.PostulerComplementaire = function (reference,ti,prenom) {     
        $("#section-detail-offre-emploi-btn-postuler").loading(   
        this.ajaxEnCours =  $.ajax({
            type     : 'POST',
            dataType : 'json',
            url      : ajax_kinougarde_object.ajaxurl,
            data     : {action : 'ajax_add_offre_postuler', reference : reference , ti : ti},
            success  : function (reponse) {
               if (reponse.success) {
                    $("#section-detail-offre-emploi-btn-postuler").parent().html('<span class="deja-postule">'+ prenom + ', merci d\'avoir postulé chez kinougarde</span>');                    

                    // Ajout de la reference de l'offre dans la liste des offres déjà postulées
                    try {
                        var offresDejaPostulees = Kinougarde.GetStorage("offres-emploi-postulees");
                        if (typeof(offresDejaPostulees)==='undefined' || offresDejaPostulees===null) {
                            offresDejaPostulees= [];
                        }
                        // Ajout uniquement si non présent dans offresDejaPostulees       
                        offresDejaPostulees.push(reference);        
                        Kinougarde.SetStorage("offres-emploi-postulees",offresDejaPostulees.filter((item, pos) => offresDejaPostulees.indexOf(item) === pos));
                        } catch (e) {}
                    }
            },                    
            error: function (reponse) {
                // Affichage d'un message d'erreur                  
                $("#section-detail-offre-emploi-btn-postuler").parent().html(Kinougarde.Form.getMessageErrorAjax());                                                                      
            }
        }));  
    }
    
})(window)


